import React from 'react';

import ListPage from '../../sharedModules/listPage/ListPage';

const SpotQuotesListPage: React.FC = () => {
  const spotQuoteColumns = [
    {
      name: 'Customer',
      selector: 'customer_name',
      sortable: true,
      grow: 1,
    },
    {
      name: 'Location',
      selector: 'job_location',
      sortable: true,
    },
    {
      name: 'Order',
      selector: 'work_order_number',
      sortable: true,
      grow: 0.5,
    },
    {
      name: 'Completed',
      selector: 'completed_at_with_time',
      sortable: false,
      grow: 1,
    },
    {
      name: 'Webhook Received At',
      selector: 'webhook_received_at_with_time',
      sortable: false,
      grow: 1,
    },
  ];

  const defaultFilterSetting = { webhook_received_at_not_null: 1 };

  return (
    <ListPage
      clickableRows
      columns={spotQuoteColumns}
      defaultFilters={defaultFilterSetting}
      controller="spot_quotes/xoi_jobs"
      defaultSort="webhook_received_at desc"
      queryPlaceholder="Filter by customer name..."
      rowClickPath="spot_quotes"
      title="Spot Quotes"
    />
  );
};

export default SpotQuotesListPage;
